import { useQuery } from "react-query";
import { getCamerasByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetCamerasByRecordNumber = (recNumber) => {
  return useQuery(
    ["GetCamerasByRecordNumber", recNumber],
    () => getCamerasByRecordNumber(recNumber),
    { refetchOnWindowFocus: false }
  );
};
